import { useState } from 'react';

export default function useDictationRecognition(onResult, onStateChange) {
  const [isRecording, setIsRecording] = useState(false);

  const startRecognition = () => {
    if (!('webkitSpeechRecognition' in window)) {
      alert('Your browser does not support speech recognition.');
      return;
    }

    const recognition = new window.webkitSpeechRecognition();
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang = 'en-GB';

    onStateChange?.('activating');

    recognition.onstart = () => {
      console.log('[Speech Recognition] Started');
      setIsRecording(true);
      onStateChange?.('recording');
    };

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      onResult(transcript);
    };

    recognition.onerror = (event) => {
      console.error('[Speech Recognition] Error:', event.error);
    };

    recognition.onend = () => {
      console.log('[Speech Recognition] Ended');
      setIsRecording(false);
      onStateChange?.('inactive');
    };

    recognition.start();
  };

  return { isRecording, startRecognition };
}
